module.exports = __webpack_public_path__ + "media/images/logos/telenor-5d640ddf6dfc270b4ed3c4fffec37b43.png";